<template>
  <div class="BitePostButton">
    <button
      class="button-unstyled interactive"
      :title="$t('tool_tip.favorite')"
      @click.prevent="bitePost()"
    >
      <FAIcon
        class="fa-scale-110 fa-old-padding"
        icon="tooth"
      />
    </button>
  </div>
</template>

<script src="./bite_post_button.js"></script>

<style lang="scss">
@import '../../_variables.scss';

.BitePostButton {
  display: flex;

  > :first-child {
    padding: 10px;
    margin: -10px -8px -10px -10px;
  }

  .action-counter {
    pointer-events: none;
    user-select: none;
  }

  .interactive {
    &:hover .svg-inline--fa {
      color: $fallback--text;
      color: var(--text, $fallback--text);
    }
  }
}
</style>
